import {
  TemplateStructureEnum,
  ConfigurationPanelStructure,
  ConfigurationPanelStructureItemEnum,
  TabItem,
  BackgroundImageOptionTypeEnum, ComponentNameEnum,
  Property, ResponsiveDisplayStackEnum,
} from '@/types';
// eslint-disable-next-line import/no-cycle
import {
  setBackgroundImage,
  setBackgroundImageProperty, setCssProperty, setCssPropertyAndRemoveIfZero,
} from '@/components/template-builder/setters';
// eslint-disable-next-line import/no-cycle
import {
  getBackgroundImageValue,
  getCssPropertyByName,
} from '@/components/template-builder/getters';
// eslint-disable-next-line import/no-cycle
import { getTemplateIframeDocument } from '@/components/template-builder/utils/helpers';
import getResponsiveDisplayStackFieldConfig from '@/components/template-builder/config/fields/responsive-display-stack-config';
import getBackgroundImageFieldConfig from '@/components/template-builder/config/fields/background-image-config';
import getColorFieldConfig from '@/components/template-builder/config/fields/color-config';
import getVerticalSpacesFieldConfig from '@/components/template-builder/config/fields/vertical-spaces-config';
import getHorizontalSpacesFieldConfig from '@/components/template-builder/config/fields/horizontal-spaces-config';

export const rowTabItemConfig: TabItem = {
  type: ConfigurationPanelStructureItemEnum.TAB_ITEM,
  tabItemType: TemplateStructureEnum.LINE,
  label: 'templateBuilder.configs.line',
  tabPanel: {
    items: [
      {
        type: ConfigurationPanelStructureItemEnum.FIELDS_GROUP,
        label: 'templateBuilder.configs.line',
        selector: 'body #spm_body #{LINE_ID}',
        items: [
          {
            label: 'templateBuilder.fields.backgroundImage',
            selector: 'body #spm_body #{LINE_ID}',
            properties: [
              { name: 'background-image', getter: getBackgroundImageValue, setters: [setBackgroundImage] },
              { name: 'background-size', getter: getCssPropertyByName, setters: [setBackgroundImageProperty] },
              { name: 'background-position-x', getter: getCssPropertyByName, setters: [setBackgroundImageProperty] },
              { name: 'background-position-y', getter: getCssPropertyByName, setters: [setBackgroundImageProperty] },
              { name: 'background-repeat', getter: getCssPropertyByName, setters: [setBackgroundImageProperty] },
            ],
            ...getBackgroundImageFieldConfig(BackgroundImageOptionTypeEnum.FULL),
          },
          {
            label: 'templateBuilder.fields.backgroundColor',
            selector: 'body #spm_body #{LINE_ID}',
            properties: [{
              name: 'background',
              getter: getCssPropertyByName,
              setters: [setCssProperty],
            }],
            ...getColorFieldConfig(undefined, true, true),
          },
          {
            label: 'templateBuilder.fields.internalMargins',
            selector: 'body #spm_body #{LINE_ID}',
            properties: [
              { name: 'padding-top', getter: getCssPropertyByName, setters: [setCssPropertyAndRemoveIfZero] },
              { name: 'padding-bottom', getter: getCssPropertyByName, setters: [setCssPropertyAndRemoveIfZero] },
              { name: 'padding-left', getter: getCssPropertyByName, setters: [setCssPropertyAndRemoveIfZero] },
              { name: 'padding-right', getter: getCssPropertyByName, setters: [setCssPropertyAndRemoveIfZero] },
            ],
            componentName: ComponentNameEnum.SPACES,
            options: {
              ...getVerticalSpacesFieldConfig('padding').options,
              ...getHorizontalSpacesFieldConfig('padding').options,
            },
          },
          {
            label: 'templateBuilder.fields.responsiveRow',
            selector: 'body #spm_body #{LINE_ID}',
            displayToggle: false,
            properties: [
              {
                name: 'spm_responsive',
                getter: (selector: string): string => {
                  const template = getTemplateIframeDocument();
                  const element: HTMLElement | null = template?.querySelector(selector);
                  if (element?.classList.contains('spm_responsive_no')) {
                    return ResponsiveDisplayStackEnum.NO_STACK;
                  }
                  if (element?.classList.contains('spm_responsive_reverse')) {
                    return ResponsiveDisplayStackEnum.RTL;
                  }
                  return ResponsiveDisplayStackEnum.LTR;
                },
                setters: [(selector: string, property: Property) => {
                  const template = getTemplateIframeDocument();
                  const elements: Array<HTMLElement> = Array.from(template?.querySelectorAll(selector));
                  elements.forEach((element: HTMLElement) => {
                    element.classList.remove('spm_responsive_no', 'spm_responsive_reverse');
                    if (property.value === ResponsiveDisplayStackEnum.NO_STACK) {
                      element.classList.add('spm_responsive_no');
                    } else if (property.value === ResponsiveDisplayStackEnum.RTL) {
                      element.classList.add('spm_responsive_reverse');
                    }
                  });
                }],
              },
            ],
            ...getResponsiveDisplayStackFieldConfig('spm_responsive', ''),
          },
        ],
      },
    ],
  },
};

const rowItemConfig: ConfigurationPanelStructure = {
  items: [
    rowTabItemConfig,
  ],
};

export default rowItemConfig;
